module.exports = __webpack_public_path__ + "01-thumbnail.jpg?34682936440aa0942a1e2027b1a82faa";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/01-thumbnail.jpg
// module id = 38
// module chunks = 0